import { get, jsonPut, del, jsonPost } from '@client/lib/request';
import { Cart } from '@pegasus/cart';
import { AddItemProps } from '@pegasus/cart/types/services';

export const getCart = (): Promise<Cart> => get('/api/cart');

export const extendCart = () => jsonPut('/api/cart');

export const deleteCartItem = (itemSku: string) => del(`/api/cart/items/${itemSku}`);

export const addItemToCart = (props: AddItemProps) => jsonPut('/api/cart/items', props);
